import api from "@/api.js";

export default {
  namespaced: true,
  modules: {

  },
  state: {
    list: [],
    listLoading: false,
    selectedFeaturedListing: null
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setSelectedFeaturedListing(state, payload) {
      state.selectedFeaturedListing = payload
    }
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("solutions/findEntries/featuredListings");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadAllBySolutionsID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("solutions/findEntries/featuredListings/bySolutionsID", { params: { id: id } });
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadByID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("solutions/findEntries/featuredListings/byID", { params: { id: id } });
      commit("setSelectedFeaturedListing", list.data[0]);
      commit("setListLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("solutions/findEntries/featuredListings", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAllBySolutionsID", payload.solutions_id);
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};

      //Uploading Image
      if (payload.imageUrl) {
        let uploadImageResult = await api.post('solutions/findEntries/featuredListings/uploadImage', {
          id: payload.id,
          imageData: payload.imageUrl.dataUrl
        })
        delete payload.imageUrl;
        if (uploadImageResult.data.Result == "Success") {
          payload.imageUrl = uploadImageResult.data.objectUrl;
        }
      }

      await api
        .put(`solutions/findEntries/featuredListings`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAllBySolutionsID", payload.solutions_id);
      return returnData;
    },
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    selectedFeaturedListing(state) {
      return state.selectedFeaturedListing
    }
  }
}
